<template>
  <div class="share-panel">
    <input v-model="title" class="title" type="text" placeholder="请输入标题" />
    <div class="divider-line"></div>
    <div ref="contenteditable" class="content" contenteditable="true" placeholder="请输入正文内容"></div>
    <div class="share-img-wrap">
      <img class="share-img" :src="shareBase64" />
    </div>
    <div style="text-align: right; margin-top: 14px;">
      <button class="share-btn" @click="handleShare">分享至社区</button>
    </div>
  </div>
</template>
<script>
import { dataURLtoFile } from "@/plugins/util";
import { uploadFile } from "@/plugins/uploadFile";

export default {
  name: "SharePanel",
  props: {
    shareBase64: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: ""
    };
  },
  methods: {
    async handleShare() {
      if (!this.title) {
        this.$message.warning("请输入标题");
        return;
      }

      const url = await this.uploadImage(dataURLtoFile(this.shareBase64, `${Date.now()}.png`));
      this.$emit("shareSubmit", {
        title: this.title,
        summary: this.$refs.contenteditable.innerText,
        image_list: [url],
        thumb: url
      });
      this.title = "";
      this.$refs.contenteditable.innerHTML = "";
    },
    async uploadImage(file) {
      try {
        const result = await uploadFile({
          file,
          accept: "png"
        });
        return result.url;
      } catch (error) {
        debugger;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.share-panel {
  .title {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 20px;
    font-weight: 500;
    color: rgba(51, 51, 51, 0.9);
    padding: 8px;
    width: 100%;
  }
  .divider-line {
    height: 2px;
    background-color: #f9f9f9;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.7);
    min-height: 42px;
    max-height: 60px;
    padding: 8px;
    box-sizing: content-box;
    margin-bottom: 40px;
    overflow: auto;
    &:empty:before {
      content: attr(placeholder);
      color: #999;
    }
  }
  .share-img-wrap {
    background-color: #f2f4f7;
    padding: 10px 0;
    border-radius: 16px;
    .share-img {
      width: 380px;
      display: block;
      margin: auto;
      border-radius: 16px;
    }
  }
  .share-btn {
    width: 144px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    outline: none;
    background-color: #00afe8;
    color: #fff;
    font-size: 15px;
    border-radius: 8px;
  }
}
</style>
